import React from 'react';
import { format } from 'date-fns';
import StatusBadge from '../common/StatusBadge';
import { StatusOverview as StatusOverviewType } from '../../types';

interface StatusOverviewProps {
  data: StatusOverviewType | null;
  isLoading: boolean;
}

const StatusOverview: React.FC<StatusOverviewProps> = ({ data, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-64 mb-4"></div>
          <div className="h-4 bg-gray-200 rounded w-48"></div>
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <p className="text-gray-500">Unable to load status information.</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <StatusBadge status={data.status} size="lg" />
          {data.message && (
            <p className="mt-3 text-gray-600">{data.message}</p>
          )}
        </div>
        <p className="text-sm text-gray-400">
          Updated {format(new Date(data.updatedAt), 'MMM d, yyyy h:mm a')}
        </p>
      </div>
    </div>
  );
};

export default StatusOverview;
